import { putResolve, put, select } from 'redux-saga/effects'

import Zoid from 'common/modules/zoid'

import Lifecycle from 'common/modules/lifecycle'

import {
    LAUNCHER_TAG,
    HEADER_TAG,
    MENU_TAG,
    PROMPT_TAG,
} from 'common/tags'
import Loader from '../../loader'

import { creators } from '../actions'

export default function* watchZoidInit() {
    const {
        adBlockDetector,
        accessToken,
        content,
        events,
        refreshToken,
        publisherId,
    } = yield select(Zoid.selectors.getXprops)

    if (accessToken || refreshToken) {
        yield putResolve(creators.updateTokens({
            accessToken,
            refreshToken,
        }))
    }

    const payload = yield select(Zoid.selectors.getXpropsChildPayload)

    yield put(creators.createChild({ frame: LAUNCHER_TAG, payload }))
    yield put(creators.createChild({ frame: MENU_TAG, payload }))
    yield put(creators.createChild({ frame: PROMPT_TAG, payload }))
    yield put(creators.createChild({ frame: HEADER_TAG, payload }))

    events.init()

    yield put(Lifecycle.creators.picoInit())

    const scope = (refreshToken ? 'user' : 'guest')

    const adBlocking = yield adBlockDetector()

    yield put(Loader.creators.getLoader({
        scope,
        publisherId,
        requestPayload: {
            ...content,
            adBlocking,
        },
    }))
}
